import { RootState } from '@src/state/types'

export const isAppInitialized = (state: RootState): boolean => state.app.initialized



// WEBPACK FOOTER //
// ./src/state/app/selectors.ts